import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMediaQuery, Dialog, DialogTitle, DialogContent, IconButton, Tooltip, Typography, } from "@mui/material";
import Close from "@mui/icons-material/Close";
import styles from "./modal.module.scss";
export const Modal = ({ children, open, onClose, title, hideTitleTooltip, hideCloseButton: hideCloseButtonProp = !onClose, fullWidth, }) => {
    const fullScreen = useMediaQuery("(max-width: 768px)");
    const hideCloseButton = !onClose || hideCloseButtonProp;
    const hideTitleBar = !title && hideCloseButton;
    const calculateMaxWidth = () => {
        if (fullScreen) {
            return "100%";
        }
        else if (fullWidth) {
            return "calc(100% - 300px)";
        }
        else {
            return "460px";
        }
    };
    return (_jsxs(Dialog, { "aria-labelledby": "modal", id: "modal", fullScreen: fullScreen, onClose: onClose ?? (() => undefined), open: open, scroll: "paper", PaperProps: {
            sx: {
                maxWidth: calculateMaxWidth(),
                maxHeight: fullScreen ? "100%" : "calc(100% - 48px)",
            },
        }, children: [!hideTitleBar && (_jsxs(DialogTitle, { id: "modal-title", className: styles.modalTitle, children: [_jsx(Tooltip, { title: hideTitleTooltip ? "" : title ?? "", arrow: true, placement: "top", children: _jsx(Typography, { component: "span", id: "modal-title", className: styles.text, children: title }) }), !hideCloseButton && (_jsx(IconButton, { "aria-label": "close modal", onClick: onClose ?? (() => undefined), size: "small", children: _jsx(Close, {}) }))] })), _jsx(DialogContent, { sx: { padding: "24px 32px" }, children: _jsx("div", { className: styles.modalBody, children: children }) })] }));
};
//# sourceMappingURL=modal.js.map